export var JointVentureContactTypes;
(function (JointVentureContactTypes) {
    JointVentureContactTypes["SKYPE"] = "skype";
    JointVentureContactTypes["QQ"] = "qq";
    JointVentureContactTypes["TELEGRAM"] = "telegram";
    JointVentureContactTypes["BUBBLE"] = "bubble"; // 後端傳送 type 維持 bubble，故暫不修改
})(JointVentureContactTypes || (JointVentureContactTypes = {}));
//# sourceMappingURL=JointVentureContactTypes.js.map